__turbopack_context__.v({
  "root": "FoldersTypeFilter-module__QYp_mG__root",
  "shared": "FoldersTypeFilter-module__QYp_mG__shared",
});
